import { CourseScreen } from "../../features/course";

/** FS-04 장애물 코스 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/course */
export default function CoursePage() {
  return <CourseScreen />;
}
